import { set, toggle } from '@/utils/vuex'
import { get } from 'https';

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  setSelectedMenu: set('selectedMenu'),
  toggleDrawer: toggle('drawer'),
}
